import React, {Fragment, useContext, useEffect, useState} from "react";
import {Text} from "../../components/inputs/Text";
import {ImageDialog} from "../../components/inputs/ImageDialog";
import {ServerContext} from "../../serverContext/ServerProvider";
import {Loader} from "../../components/Loader";
import {TextArea} from "../../components/inputs/TextArea";
import {NotificatorContext} from "../../components/Notificator";

export const Overview = ({good}) => {
    //mainSubHeader, pages[{header,subheader,image,text}]
    const {getOverview, overview, updateOverview} = useContext(ServerContext)
    const {showNotification} = useContext(NotificatorContext)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        async function wtf() {
            await getOverview(good.overview, () => {
                setLoading(false)
            })
        }

        wtf()
    }, [])

    useEffect(() => {
        if (!loading && overview) {
            init()
        }
    }, [overview, loading])

    const [mainSubheader, setMainSubheader] = useState('')
    //map by headers
    const [headers, setHeaders] = useState([])
    const [subHeaders, setSubHeaders] = useState([])
    const [images, setImages] = useState([])
    const [texts, setTexts] = useState([])

    const init = () => {
        setMainSubheader(overview.subHeader)
        overview.pages.map(page => {
            setHeaders(prev => prev.concat([page.header]))
            setSubHeaders(prev => prev.concat([page.subHeader]))
            setTexts(prev => prev.concat([page.text]))
            setImages(prev => prev.concat([page.image]))
            return page
        })
    }

    const removeHandler = (index) => {
        setSubHeaders(prev => prev.filter((a, i) => index !== i))
        setImages(prev => prev.filter((a, i) => index !== i))
        setTexts(prev => prev.filter((a, i) => index !== i))
        setHeaders(prev => prev.filter((a, i) => index !== i))
    }

    const addField = () => {
        setSubHeaders(prev => prev.concat([' ']))
        setTexts(prev => prev.concat([' ']))
        setImages(prev => prev.concat([null]))
        setHeaders(prev => prev.concat([' ']))
    }

    const changeHandler = (value, args) => {
        args.setter(prev => prev.map((item, i) => {
            if (i === args.index) {
                return value
            }
            return item
        }))
    }

    const uploadHandler = (file, {index}) => {
        setImages(prev => prev.map((img, i) => {
            if (i === index) {
                return file
            }
            return img
        }))
    }

    const save = () => {
        const toSave = {
            subHeader: mainSubheader,
            pages: headers.map((header, index) => {
                return {
                    header,
                    subHeader: subHeaders[index],
                    text: texts[index],
                    image: images[index]
                }
            })
        }
        updateOverview(good.overview, toSave, () => showNotification('Changes have been saved on server'))
    }

    return (
        <Fragment>
            {loading ? <Loader/> : (
                <Fragment>
                    <div className='container pl-0 pt-5 editor_container'>
                        <div className="row mb-5 mt-5">
                            <div className="col-4 text-muted pt-1 pb-1">Main Sub Header:</div>
                            <div className="col-8 text-dark">
                                <Text state={mainSubheader} setState={setMainSubheader}/>
                            </div>
                        </div>
                        {headers.map((page, index) => (
                            <div
                                className={'editor_subcontainer'}
                                key={index}>
                                <div className="row mb-5">
                                    <div className="col-4 text-muted pt-1 pb-1">Header:</div>
                                    <div className="col-8 text-dark">
                                        <Text
                                            state={headers[index]}
                                            setState={changeHandler}
                                            setterArgs={{
                                                index,
                                                setter: setHeaders
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="row mb-5">
                                    <div className="col-4 text-muted pt-1 pb-1">Sub header:</div>
                                    <div className="col-8 text-dark">
                                        <TextArea
                                            state={subHeaders[index]}
                                            setState={changeHandler}
                                            rows={1}
                                            setterArgs={{
                                                index,
                                                setter: setSubHeaders
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="row mb-5">
                                    <div className="col-4 text-muted pt-1 pb-1">Image:</div>
                                    <div className="col-8 text-dark">
                                        <ImageDialog
                                            imageSrc={images[index]}
                                            handler={uploadHandler}
                                            args={{index}}
                                        />
                                    </div>
                                </div>
                                <div className="row mb-5">
                                    <div className="col-4 text-muted pt-1 pb-1">Text:</div>
                                    <div className="col-8 text-dark">
                                        <TextArea
                                            state={texts[index]}
                                            setState={changeHandler}
                                            setterArgs={{
                                                index,
                                                setter: setTexts
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-10 pt-1 ">
                                    </div>
                                    <div className="col-2 align-self-end pt-1 ">
                                        <button
                                            className='remove_button'
                                            onClick={() => removeHandler(index)}
                                        >Remove
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <button className="save_button float-left" onClick={addField}>Add one</button>
                    <button className='save_button float-right' onClick={save}>Save</button>
                </Fragment>
            )}
        </Fragment>
    )
}